import { render, staticRenderFns } from "./tenants.vue?vue&type=template&id=4d2e40d9&"
import script from "./tenants.vue?vue&type=script&lang=ts&"
export * from "./tenants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2e40d9')) {
      api.createRecord('4d2e40d9', component.options)
    } else {
      api.reload('4d2e40d9', component.options)
    }
    module.hot.accept("./tenants.vue?vue&type=template&id=4d2e40d9&", function () {
      api.rerender('4d2e40d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/tenants/views/tenants.vue"
export default component.exports